<template>
  <div class="container mb-25">
    <div class="row justify-content-center">
      <div class="col col-sm-10 col-md-8 col-lg-7 col-xl-6 col-xxl-6 col-xxxl-6">
        <div class="card card-prelogin border-0 rounded-0 bg-white authentication-card">
          <div class="card-body letter-spacing">
            <h4 class="fw-bold mb-0">
              {{ $t('feature.auth.$login.title') }}
            </h4>
            <form id="login-form" v-on:submit="submit">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  {{ $t('form.email.label') }}
                </label>
                <input type="email" title="Email" class="form-control shadow-none text-black" v-model="username"
                  :class="[{ 'is-invalid': submitted && !usernameIsValid }]" :placeholder="$t('form.email.placeholder')"
                  required pattern="[^@\s]+@[^@\s]+\.[^@\s]+" />
              </div>
              <div class="form-check form-group mb-15 mb-sm-20 mb-md-25">
                <input class="form-check-input shadow-none" type="checkbox" v-model="accept" id="accept">
                <label class="form-check-label fw-medium position-relative top-1" for="accept">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec suscipit auctor dui, id faucibus nisl
                </label>
            </div>

              <button class="default-btn transition fw-medium fs-md-15 fs-lg-16 d-block w-100" type="submit"
                v-on:click="setPristine" v-if="!loading">
                {{ $t('cta.login') }}
              </button>
              <SpinnerLoading v-else />
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- ERROR MESSAGE -->
    <div class="row justify-content-center">
      <div class="col col-sm-10 col-md-8 col-lg-7 col-xl-6 col-xxl-6 col-xxxl-6">
        <div class="alert alert-danger alert-dismissible fade border-0 border-danger-subtle border-top rounded-0 m-0"
          role="alert" id="errorMessage">
          <strong>{{ errorMessage }}</strong>
          <button type="button" class="btn-close" v-on:click="hideError" aria-label="Close"></button>
        </div>
      </div>
    </div>
  </div>

  <AlertModal id="alertModal" :title="$t('error.something_went_wrong')" :message="errorMessage" @confirm="redirect"
    :dismissible="false" />
  <AlertModal id="successModal" :title="$t('feature.auth.invitation')"
    :message="$t('feature.auth.$invitation.accept_success_message')" @confirm="redirect" />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import stateStore from "../../../utils/store";
import API from '../../../services/api/api.service';
import { Alert, Modal } from "bootstrap";
import SpinnerLoading from "@/components/Widgets/Spinner.vue";
import AlertModal from "@/components/Widgets/AlertModal.vue";
import OTPstore from "@/utils/otp.store";

export default defineComponent({
  name: "OTPInvitationForm",
  components: {
    SpinnerLoading,
    AlertModal
  },
  data: function() {
    return {
      loading: false as boolean,
      username: '' as string,
      accept: false as boolean,
      submitted: false as boolean,
      successModal: null as Modal | null,
      alertModal: null as Modal | null,
      errorAlert: undefined as Alert | undefined,
      errorMessage: undefined as string | undefined,
      token: this.$route?.params.token as string | undefined,
      errors: undefined as any,
    }
  },
  mounted() {
    this.errorMessage = this.$t('error.something_went_wrong');
    this.errorAlert = new Alert('#errorMessage');
    this.alertModal = new Modal('#alertModal', {});
    this.successModal = new Modal('#successModal', {});

    if (this.token === undefined || this.token === null || this.token === '') {
      this.alertModal?.show();
      return;
    }
    API.getInviteToken({ token: this.token ?? '' }).then((response) => {
      this.username = response.data.data.email;
    }).catch((error) => {
      console.log('ERROR', error);
      this.errorMessage = error?.data?.message ?? this.$t('error.something_went_wrong');
      // this.alertModal?.show();
    });
  },
  computed: {
    usernameIsValid(): boolean {
      var EMAIL_PATTERN = '^[^@\\s]+@[^@\\s]+\\.[^@\\s]+$';
      var EMAIL_REGEXP = new RegExp(EMAIL_PATTERN, 'i');
      return EMAIL_REGEXP.test(this.username);
    },
  },
  methods: {
    submit(e) {
      this.submitted = true;
      e?.preventDefault();
      this.login();
    },
    login() {
      this.loading = true;
      API.acceptOTPInvite({ token: this.token! , email: this.username}).then((response) => {
        if(response.status === 200 && response.data.success === true) {
          OTPstore.storeLoginChallangeToken(response.data.challenge_token);
          
          this.$router.push(`/invitations-otp/${this.token}/verify`);
        } else {
          this.showError(response.data?.message ?? this.$t('error.something_went_wrong'));
        }
      }).catch((error) => {
        this.showError(error);
      }).finally(() => {
        this.loading = false;
      });
    },
    setPristine() {
      this.submitted = true;
    },
    showError(error?: any) {
      if ('response' in error) {
        this.errorMessage = error.response?.data?.message ?? this.$t('error.something_went_wrong');
      } else {
        this.errorMessage = this.$t('error.connection_error');
      }
      const error_element = document.getElementById('errorMessage');
      error_element?.classList.add('show');
      setTimeout(() => {
        this.hideError();
      }, 5000)
    },
    hideError() {
      const error = document.getElementById('errorMessage');
      error?.classList.remove('show');
    },
    redirect() {
      this.$router.push('/login');
    },
  }
});
</script>